import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';


import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput"
import ActionAdd from '../../store/action/Template/Add'
import ActionEdit from '../../store/action/Template/Edit'

import {IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetGroupTemplate from "../../store/action/GroupTemplate/Fetch";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
          'template-id':'',
          'message-template' : '',
          'group-id'        : '',
          'client-id': '',
          'division-id': '',
          'sender-id':'',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

    componentDidMount(){
        this.props.actionGetAllClient();
        if(this.props.actionType == IsEdit) {
            this.props.actionGetAllDivision( this.props.item.get('client-id'));
            this.props.actionGetAllSender( this.props.item.get('client-id'),  this.props.item.get('division-id'));
        }
    }

  handleChange(field, value) {

    var formVal = this.state.form;
    formVal = formVal.set(field,value);
      if(field === 'client-id'){
          this.setState({client_id: value})
          this.props.actionGetAllSender(value);
          this.props.actionGetAllDivision(value);

      }

      if (field === 'division-id') {
          let clientId = this.state.client_id;
          if (clientId == null || clientId == "" || clientId == undefined) clientId = this.props.item.get('client-id')
          this.props.actionGetAllSender(clientId, value);
      }

    this.setState({ form:formVal })
  }
  handleSelectChange(field){
    var formVal = this.state.form;
    // eslint-disable-next-line no-restricted-globals
    formVal = formVal.set(field,event.target.value); 
    this.setState({ form:formVal })
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;
      if(form.get('sender-id') == '' || form.get('sender-id') == null || form.get('sender-id') == undefined ) {
          this.setState({error : "Sender cannot be empty!"});
          toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);

          return  false;
      }

    if(form.get('message-template') === ''){
        this.setState({error : "message cannot be empty!"});
        toast.error("message cannot be empty!", toast.POSITION.TOP_RIGHT);
    }else{

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code blocks
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                'group-id'          : form.get('group-id'),
                'message-template'  : form.get('message-template'),
                'sender-id'         : form.get('sender-id'),
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error("Save Failed!", toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
              'group-id'          : form.get('group-id'),
              'template-id'       : form.get('template-id'),
              'message-template'  : form.get('message-template'),
              'sender-id'         : form.get('sender-id'),
          }
        };

        var response = await this.props.actionEdit(data);
        if(response.ok){
          toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS({
              'group-id'          : this.props.item.get('group-id'),
              'template-id': this.props.item.get('template-id'),
              'message-template' : this.props.item.get('message-template'),
              'client-id' : this.props.item.get('client-id'),
              'division-id': this.props.item.get('division-id'),
              'sender-id': this.props.item.get('sender-id'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
      const { form, errors, disabled } = this.state;
      const {supervisorsall} = this.props;
      return (
          <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Client"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Divison</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='division-id'
                                value={form.get('division-id')}
                                options={fromJS({
                                    'source': this.props.divisionall,
                                    'value': 'division-id',
                                    'label': 'division-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Division"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='sender-id'
                                value={form.get('sender-id')}
                                options={fromJS({
                                    'source': this.props.senderall,
                                    'value': 'sender-id',
                                    'label': 'sender-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Sender"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Group Template</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='group-id'
                                value={form.get('group-id')}
                                options={fromJS({
                                    'source': this.props.grouptemplate,
                                    'value': 'group-id',
                                    'label': 'group-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Group Template"
                                disabled={this.state.disabled}
                                hasError={errors.has('group-id')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Message</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                textarea
                                field={'message-template'}
                                value={ form.get('message-template')}
                                onChange={(field, value) => this.handleChange(field,value)}
                                placeholder="message"
                                disabled={ disabled }
                                hasError={errors.has('message')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                value="Cancel"
                                onClick={ this.handleCancel }>
                                Cancel
                            </button>
                            <button type="button"
                                className="btn btn-wide btn-success"
                                onClick={ this.handleSubmit }>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
          </div>
      );
  }
}


export default connect(
  (state) => {
      return {
          supervisorsall: state.user.supervisorsall,
          grouptemplate: state.user.grouptemplate,
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
      actionGetGroupTemplate: ActionGetGroupTemplate
  }, dispatch),
)(Form);